import { faArrowsRotate as arrowsRotate } from '@fortawesome/pro-solid-svg-icons/faArrowsRotate';
import { faAt as at } from '@fortawesome/pro-solid-svg-icons/faAt';
import { faAward as award } from '@fortawesome/pro-solid-svg-icons/faAward';
import { faBadgePercent as badgePercent } from '@fortawesome/pro-solid-svg-icons/faBadgePercent';
import { faBars as bars } from '@fortawesome/pro-solid-svg-icons/faBars';
import { faBoxOpen as boxOpen } from '@fortawesome/pro-solid-svg-icons/faBoxOpen';
import { faCircleArrowRight as circleArrowRight } from '@fortawesome/pro-solid-svg-icons/faCircleArrowRight';
import { faCircleCheck as circleCheck } from '@fortawesome/pro-solid-svg-icons/faCircleCheck';
import { faCircleExclamation as circleExclamation } from '@fortawesome/pro-solid-svg-icons/faCircleExclamation';
import { faClock as clock } from '@fortawesome/pro-solid-svg-icons/faClock';
import { faCloudUploadAlt as cloudUploadAlt } from '@fortawesome/pro-solid-svg-icons/faCloudUploadAlt';
import { faCode as code } from '@fortawesome/pro-solid-svg-icons/faCode';
import { faCoins as coins } from '@fortawesome/pro-solid-svg-icons/faCoins';
import { faCreditCard as creditCard } from '@fortawesome/pro-solid-svg-icons/faCreditCard';
import { faDatabase as database } from '@fortawesome/pro-solid-svg-icons/faDatabase';
import { faDollarSign as dollarSign } from '@fortawesome/pro-solid-svg-icons/faDollarSign';
import { faEnvelope as envelope } from '@fortawesome/pro-solid-svg-icons/faEnvelope';
import { faEuroSign as euroSign } from '@fortawesome/pro-solid-svg-icons/faEuroSign';
import { faEye as eye } from '@fortawesome/pro-solid-svg-icons/faEye';
import { faEyeSlash as eyeSlash } from '@fortawesome/pro-solid-svg-icons/faEyeSlash';
import { faFireFlameCurved as fireFlameCurved } from '@fortawesome/pro-solid-svg-icons/faFireFlameCurved';
import { faGenderless as genderless } from '@fortawesome/pro-solid-svg-icons/faGenderless';
import { faGlobe as globe } from '@fortawesome/pro-solid-svg-icons/faGlobe';
import { faInfoCircle as infoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import { faLink as link } from '@fortawesome/pro-solid-svg-icons/faLink';
import { faLock as lock } from '@fortawesome/pro-solid-svg-icons/faLock';
import { faMagnifyingGlass as magnifyingGlass } from '@fortawesome/pro-solid-svg-icons/faMagnifyingGlass';
import { faMars as mars } from '@fortawesome/pro-solid-svg-icons/faMars';
import { faMarsAndVenus as marsAndVenus } from '@fortawesome/pro-solid-svg-icons/faMarsAndVenus';
import { faMercury as mercury } from '@fortawesome/pro-solid-svg-icons/faMercury';
import { faMessages as messages } from '@fortawesome/pro-solid-svg-icons/faMessages';
import { faPeopleGroup as peopleGroup } from '@fortawesome/pro-solid-svg-icons/faPeopleGroup';
import { faPoundSign as poundSign } from '@fortawesome/pro-solid-svg-icons/faPoundSign';
import { faReceipt as receipt } from '@fortawesome/pro-solid-svg-icons/faReceipt';
import { faRightLeft as rightLeft } from '@fortawesome/pro-solid-svg-icons/faRightLeft';
import { faRightToBracket as rightToBracket } from '@fortawesome/pro-solid-svg-icons/faRightToBracket';
import { faRotate as rotate } from '@fortawesome/pro-solid-svg-icons/faRotate';
import { faSpinner as spinner } from '@fortawesome/pro-solid-svg-icons/faSpinner';
import { faTag as tag } from '@fortawesome/pro-solid-svg-icons/faTag';
import { faTimes as times } from '@fortawesome/pro-solid-svg-icons/faTimes';
import { faToggleOff as toggleOff } from '@fortawesome/pro-solid-svg-icons/faToggleOff';
import { faToggleOn as toggleOn } from '@fortawesome/pro-solid-svg-icons/faToggleOn';
import { faTransgender as transgender } from '@fortawesome/pro-solid-svg-icons/faTransgender';
import { faTrash as trash } from '@fortawesome/pro-solid-svg-icons/faTrash';
import { faTriangleExclamation as triangleExclamation } from '@fortawesome/pro-solid-svg-icons/faTriangleExclamation';
import { faUser as user } from '@fortawesome/pro-solid-svg-icons/faUser';
import { faUsers as users } from '@fortawesome/pro-solid-svg-icons/faUsers';
import { faVenus as venus } from '@fortawesome/pro-solid-svg-icons/faVenus';
import { faXmark as xmark } from '@fortawesome/pro-solid-svg-icons/faXmark';

const icons = {
  arrowsRotate,
  at,
  award,
  badgePercent,
  bars,
  boxOpen,
  circleArrowRight,
  circleCheck,
  circleExclamation,
  clock,
  cloudUploadAlt,
  code,
  coins,
  creditCard,
  database,
  dollarSign,
  envelope,
  euroSign,
  eye,
  eyeSlash,
  fireFlameCurved,
  genderless,
  globe,
  infoCircle,
  link,
  lock,
  magnifyingGlass,
  mars,
  marsAndVenus,
  mercury,
  messages,
  peopleGroup,
  poundSign,
  receipt,
  rightLeft,
  rightToBracket,
  rotate,
  spinner,
  tag,
  times,
  toggleOff,
  toggleOn,
  transgender,
  trash,
  triangleExclamation,
  user,
  users,
  venus,
  xmark,
};

export default icons;
